import Vue from 'vue'
import Router from 'vue-router'
import TournamentPage from '@/screens/tournament'
import MainPage from '@/screens/main_page'
import HistoryPage from '@/screens/history'
import GamePage from '@/screens/game'
import WalletPage from '@/screens/wallet'
import AccountPage from '@/screens/account'
import OffersPage from '@/screens/offers'
import RewardsPage from '@/screens/rewards'
import TransactionPage from '@/screens/transactions'
import RedeemPage from '@/screens/redeem'
import ReferralsPage from '@/screens/referrals'
import GiftCardPage from '@/screens/gift-cards'
import OfferDetailsPage from '@/screens/offer-detail'
import GiftCardDetailsPage from '@/screens/gift-card-detail'
import GameZonePage from '@/screens/game-zone'
import QuizZonePage from '@/screens/quiz-zone'
import QuizDetailsCustomPage from '@/screens/quiz-details-custom'
import QuizQuestionsPage from '@/screens/quiz-questions'
import CongratsPage from '@/screens/congrats'
import LeadboardPage from '@/screens/leadboard'
import QuizHistoryPage from '@/screens/quiz-history'
import StampCampaignPage from '@/screens/stamp-campaign'
import VueSocialSharing from 'vue-social-sharing'
import InfiniteLoading from 'vue-infinite-loading';

Vue.use(Router)
Vue.use(InfiniteLoading)
Vue.use(VueSocialSharing)

export default new Router({
  mode: "history",
  routes: [
    {
      path: '/main_page',
      name: 'main_page',
      component: MainPage
    },
    {
      path: '/',
      name: 'offers',
      component: OffersPage
    },
    {
      path: '/history',
      name: 'history',
      component: HistoryPage
    },
    {
      path: '/wallet',
      name: 'wallet',
      component: WalletPage
    },
    {
      path: '/account',
      name: 'account',
      component: AccountPage
    },
    {
      path: '/game',
      name: 'game',
      component: GamePage
    },
    {
      path: '/offers/:id',
      name: 'offer_details',
      component: OfferDetailsPage
    },
    {
      path: '/rewards',
      name: 'rewards',
      component: RewardsPage
    },
    {
      path: '/transactions',
      name: 'transactions',
      component: TransactionPage
    },
    {
      path: '/redeem',
      name: 'redeem',
      component: RedeemPage
    },
    {
      path: '/gift-cards',
      name: 'gift_cards',
      component: GiftCardPage
    },
    {
      path: '/gift-cards/:id',
      name: 'gift_card_details',
      component: GiftCardDetailsPage
    },
    {
      path: '/game-zone',
      name: 'game_zone',
      component: GameZonePage
    },
    {
      path: '/tournament',
      name: 'tournament',
      component: TournamentPage
    },
    {
      path: '/referrals',
      name: 'referrals',
      component: ReferralsPage
    },
    {
      path: '/quiz-zone',
      name: 'quiz_zone',
      component: QuizZonePage
    },
    {
      path: '/quiz-details-custom',
      name: 'quiz_details_custom',
      component: QuizDetailsCustomPage
    },
    {
      path: '/play-quiz',
      name: 'quiz_questions',
      component: QuizQuestionsPage
    },
    {
      path: '/congrats',
      name: 'congrats',
      component: CongratsPage
    },
    {
      path: '/leadboard',
      name: 'leadboard',
      component: LeadboardPage
    },
    {
      path: '/quiz-history',
      name: 'quiz_history',
      component: QuizHistoryPage
    },
    {
      path: '/stamp-campaign',
      name: 'stamp_campaign',
      component: StampCampaignPage
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js